import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => {
    const validate = async () => {
      if (!token || !user || user.role !== 'admin' || !user.isActive || user.kycStatus !== 'verified') {
        console.warn('[ProtectedRoute] Invalid user data:', { tokenExists: !!token, user });
        setIsValid(false);
        return;
      }

      try {
        await axios.get('https://zangena-e33a7e55637a.herokuapp.com/api/users/check', {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 5000,
        });
        console.log('[ProtectedRoute] Token validated');
        setIsValid(true);
      } catch (err) {
        console.error('[ProtectedRoute] Token validation failed:', err.response?.data || err.message);
        localStorage.clear();
        setIsValid(false);
      }
    };
    validate();
  }, [token]);

  if (isValid === null) {
    return <div className="loading-container">Loading...</div>;
  }

  return isValid ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;